import { createContext } from "react";

const PermalinkContext = createContext<string>("");

export default PermalinkContext;
